import React from 'react';

export function ShopeeIcon({ className = 'w-4 h-4' }) {
  return (
    <img
      src="/images/logo-shopee.png"
      alt="Shopee"
      className={`${className} object-contain`}
      loading="lazy"
    />
  );
}

/** TikTok Shop — menggantikan slot Tokopedia di UI */
export function TikTokShopIcon({ className = 'w-4 h-4' }) {
  return (
    <img
      src="/images/logo-tiktok-shop.png"
      alt="TikTok Shop"
      className={`${className} object-contain`}
      loading="lazy"
    />
  );
}

/** Alias lama — arahkan ke logo TikTok Shop */
export function TokopediaIcon({ className = 'w-4 h-4' }) {
  return <TikTokShopIcon className={className} />;
}

export function WhatsAppIcon({ className = 'w-4 h-4' }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 3C8.8 3 3 8.8 3 16c0 2.3.6 4.4 1.7 6.3L3 29l6.9-1.7c1.8 1 3.9 1.5 6.1 1.5 7.2 0 13-5.8 13-13S23.2 3 16 3zm7.4 18.3c-.3.9-1.8 1.7-2.5 1.8-.7.1-1.5.1-2.4-.2-.6-.2-1.3-.4-2.2-.8-3.9-1.7-6.5-5.7-6.7-6-.2-.3-1.6-2.1-1.6-4s1-2.8 1.4-3.2c.4-.4.8-.5 1.1-.5s.6 0 .8.01c.3 0 .6-.1.9.7.3.8 1.1 2.8 1.2 3s.1.4 0 .6c-.1.2-.2.4-.4.6-.2.2-.4.5-.6.7-.2.2-.4.4-.2.8s1 1.7 2.2 2.8c1.5 1.4 2.7 1.8 3.1 2s.6.2.9 0c.2-.2.9-1.1 1.2-1.4.2-.3.5-.3.8-.2.3.1 2 1 2.4 1.1.4.2.6.3.7.4.1.2.1 1-.2 1.8z"/>
    </svg>
  );
}
